import { render, staticRenderFns } from "./NsMinimalHeader.vue?vue&type=template&id=04d9897e&scoped=true&"
import script from "./NsMinimalHeader.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeader.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeader.vue?vue&type=style&index=0&id=04d9897e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d9897e",
  null
  
)

export default component.exports